module.exports = __webpack_public_path__ + "img/infineon.21d5ce89.jpg";